"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var delay_1 = __importDefault(require("delay"));
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var __1 = require("../");
var utils_1 = require("../../utils");
var Model_1 = require("../Model");
var types_1 = require("../types");
var convertCollationsToStops_1 = require("./Tour/convertCollationsToStops");
var convertSubcoToDepot_1 = require("./Tour/convertSubcoToDepot");
var generateRoutes_1 = require("./Tour/generateRoutes");
var mapOptimizationResults_1 = require("./Tour/mapOptimizationResults");
var TourState_1 = require("./TourState");
var checkIfExists = utils_1.checkIfPropertyExtists("Tour");
var Tour = /** @class */ (function (_super) {
    __extends(Tour, _super);
    function Tour(id, date, subcoId, driverId, color, vehicleType) {
        if (color === void 0) { color = ''; }
        if (vehicleType === void 0) { vehicleType = 'fossil'; }
        var _this = _super.call(this, id) || this;
        _this.saveTour = function (tourId) { return __awaiter(_this, void 0, void 0, function () {
            var params, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            date: this.getDate,
                            driverId: this.getDriverId,
                            subcontractorId: this.getSubcoId,
                            color: this.getColor,
                        };
                        if (this.vehicleType) {
                            key = 'vehicle_type';
                            params[key] = this.getVehicleType;
                        }
                        return [4 /*yield*/, Tour.makeRequest("/spatial/private/tour/" + tourId, __1.METHOD.PUT, params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.setDate = date;
        _this.setSubcoId = subcoId;
        _this.setDriverId = driverId;
        _this.setColor = color;
        _this.setVehicleType = vehicleType;
        _this.fetchSubco = _this.fetchSubco.bind(_this);
        _this.fetchDriver = _this.fetchDriver.bind(_this);
        _this.fetchLedger = _this.fetchLedger.bind(_this);
        _this.fetchCollations = _this.fetchCollations.bind(_this);
        return _this;
    }
    Object.defineProperty(Tour.prototype, "getDate", {
        // private async isTourComplete(): Promise<boolean> {
        //   const collations: TourCollation[] = await Promise.all(
        //     await this.getCollations,
        //   )
        //   const shipments: Shipment[] = await getShipmentsFromCollations(collations)
        //   const areShipmentsDelivered: boolean[] = await Promise.all(
        //     shipments.map(shipment => shipment ? shipment.isDelivered() : false),
        //   )
        //   return areShipmentsDelivered.every(isDelivered => isDelivered)
        // }
        /**
         * GETTERS
         */
        get: function () {
            return this.date;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "getSubcoId", {
        get: function () {
            return this.subcoId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "getSubco", {
        get: function () {
            return this.checkIfPropertyIsFetched('subco', this.fetchSubco);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "getDriverId", {
        get: function () {
            return this.driverId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "getDriver", {
        get: function () {
            return this.checkIfPropertyIsFetched('driver', this.fetchDriver);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "getLedger", {
        get: function () {
            return this.checkIfPropertyIsFetched('ledger', this.fetchLedger);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "getCollations", {
        get: function () {
            return this.checkIfPropertyIsFetched('collations', this.fetchCollations);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "getColor", {
        get: function () {
            return this.color;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "getVehicleType", {
        get: function () {
            return this.vehicleType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "setDate", {
        /**
         * SETTERS
         */
        set: function (date) {
            this.date = moment_1.default(date);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "setSubcoId", {
        set: function (subcoId) {
            this.subcoId = subcoId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "setSubco", {
        set: function (subco) {
            this.subco = subco;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "setDriverId", {
        set: function (driverId) {
            this.driverId = driverId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "setDriver", {
        set: function (driver) {
            this.driver = driver;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "setLedger", {
        set: function (ledger) {
            this.ledger = ledger;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "setCollations", {
        set: function (collations) {
            this.collations = collations;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "setColor", {
        set: function (color) {
            this.color = color;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tour.prototype, "setVehicleType", {
        set: function (vehicleType) {
            this.vehicleType = vehicleType;
        },
        enumerable: true,
        configurable: true
    });
    Tour.prototype.fetchSubco = function () {
        return this.fetchNestedModel('setSubco', __1.Subco.fetch, 'getSubcoId');
    };
    Tour.prototype.fetchDriver = function () {
        return this.fetchNestedModel('setDriver', __1.Driver.fetch, 'getDriverId');
    };
    Tour.prototype.fetchLedger = function () {
        return this.fetchNestedModel('setLedger', __1.TourLedger.fetchByTourId, 'getId');
    };
    Tour.prototype.fetchCollations = function () {
        return this.fetchNestedModel('setCollations', __1.TourCollation.fetchByTourId, 'getId');
    };
    Tour.prototype.addState = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var state, _a, _b, id;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = checkIfExists;
                        _b = {
                            key: 'state'
                        };
                        return [4 /*yield*/, __1.TourState.fetchByName(name)];
                    case 1:
                        state = _a.apply(void 0, [(_b.value = _c.sent(),
                                _b)]);
                        id = checkIfExists({ key: 'id', value: this.getId });
                        return [4 /*yield*/, new __1.TourLedger(undefined, id, state.getId, -1).save()];
                    case 2: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    Tour.prototype.discard = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Tour.makeRequest("/spatial/functions/discard-tour/" + this.getId, __1.METHOD.POST)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLedger()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLedger];
                }
            });
        });
    };
    Tour.prototype.planned = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Tour.makeRequest("/spatial/functions/planned-tour/" + this.getId, __1.METHOD.POST)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLedger()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLedger];
                }
            });
        });
    };
    Tour.prototype.inTransit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Tour.makeRequest("/spatial/functions/tour-in-transit/" + this.getId, __1.METHOD.POST)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchLedger()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLedger];
                }
            });
        });
    };
    Tour.prototype.complete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Tour.makeRequest("/spatial/functions/complete-tour/" + this.id, __1.METHOD.POST, {
                            tourState: TourState_1.TOUR_STATES.COMPLETED,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Tour.prototype.incomplete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // TODO: connect to real endpoint
                    return [4 /*yield*/, this.addState("TOUR_INCOMPLETE")];
                    case 1:
                        // TODO: connect to real endpoint
                        _a.sent();
                        return [4 /*yield*/, this.fetchLedger()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.getLedger];
                }
            });
        });
    };
    Tour.prototype.isActive = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id, lastEntry, state, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = checkIfExists({
                            key: 'ID',
                            value: this.getId,
                        });
                        return [4 /*yield*/, __1.TourLedger.fetchLastEntryForTour(id)];
                    case 1:
                        lastEntry = _b.sent();
                        _a = lastEntry;
                        if (!_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, lastEntry.getState];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        state = _a;
                        return [2 /*return*/, ((state &&
                                !(state.getName === TourState_1.TOUR_STATES.INCOMPLETE ||
                                    state.getName === TourState_1.TOUR_STATES.DISCARDED)) ||
                                false)];
                }
            });
        });
    };
    Tour.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var collations, _a, _b, result, _c, _d, _e, _f;
            var _this = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _b = (_a = Promise).all;
                        return [4 /*yield*/, this.getCollations];
                    case 1: return [4 /*yield*/, _b.apply(_a, [_g.sent()])];
                    case 2:
                        collations = _g.sent();
                        _d = (_c = Tour).makeRequest;
                        _e = ["/spatial/functions/store-tour",
                            __1.METHOD.POST];
                        _f = {};
                        return [4 /*yield*/, Promise.all(collations.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                                var estimation;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, item.getEstimation];
                                        case 1:
                                            estimation = _a.sent();
                                            return [2 /*return*/, {
                                                    estimatedTimeOfArrival: estimation.getTimeOfArrival || '',
                                                    polyline: item.getPolyline || '',
                                                    shipmentId: item.getShipmentId,
                                                }];
                                    }
                                });
                            }); }))];
                    case 3: return [4 /*yield*/, _d.apply(_c, _e.concat([(_f.collations = _g.sent(),
                                _f.date = this.getDate,
                                _f.driverId = this.getDriverId || undefined,
                                _f.subcontractorId = this.getSubcoId,
                                _f)]))];
                    case 4:
                        result = _g.sent();
                        this.setId = result.id;
                        result.collations.map(function (collationResult) { return __awaiter(_this, void 0, void 0, function () {
                            var collation, estimation;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        collation = collations.find(function (item) { return item.getShipmentId === collationResult.shipmentId; });
                                        if (!collation) return [3 /*break*/, 2];
                                        collation.setId = collationResult.id;
                                        return [4 /*yield*/, collation.getEstimation];
                                    case 1:
                                        estimation = _a.sent();
                                        estimation.setId = collationResult.estimation.id;
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/, this];
                }
            });
        });
    };
    Tour.prototype.optimize = function (_a) {
        var departureTime = _a.departureTime, _b = _a.handlingTime, handlingTime = _b === void 0 ? 180 : _b;
        return __awaiter(this, void 0, void 0, function () {
            var collations, _c, _d, stops, subco, depot, result;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (this.isLocked()) {
                            throw new Error("Current tour is locked and can not be optimized");
                        }
                        _d = (_c = Promise).all;
                        return [4 /*yield*/, this.getCollations];
                    case 1: return [4 /*yield*/, _d.apply(_c, [_e.sent()])];
                    case 2:
                        collations = _e.sent();
                        return [4 /*yield*/, convertCollationsToStops_1.convertCollationsToStops(collations)];
                    case 3:
                        stops = _e.sent();
                        return [4 /*yield*/, this.getSubco];
                    case 4:
                        subco = _e.sent();
                        return [4 /*yield*/, convertSubcoToDepot_1.convertSubcoToDepot(subco)];
                    case 5:
                        depot = _e.sent();
                        return [4 /*yield*/, Tour.makeRequest("/spatial/functions/optimize/tsp", __1.METHOD.POST, {
                                departure: (moment_1.default(departureTime) || subco.getDefaultStartTime).toISOString(),
                                depot: {
                                    latitude: depot.latitude,
                                    longitude: depot.longitude,
                                },
                                handlingTime: handlingTime,
                                stops: stops,
                            })];
                    case 6:
                        result = (_e.sent()).result;
                        return [4 /*yield*/, mapOptimizationResults_1.mapOptimizationResults(result, collations, true)];
                    case 7:
                        _e.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @deprecated
     * @param departureTime
     * @param handlingTime
     */
    Tour.prototype.runEstimation = function (_a) {
        var departureTime = _a.departureTime, _b = _a.handlingTime, handlingTime = _b === void 0 ? 180 : _b;
        return __awaiter(this, void 0, void 0, function () {
            var collations, _c, _d, stops, subco, depot, result;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (this.isLocked()) {
                            throw new Error("Current tour is locked and can not be optimized");
                        }
                        _d = (_c = Promise).all;
                        return [4 /*yield*/, this.getCollations];
                    case 1: return [4 /*yield*/, _d.apply(_c, [_e.sent()])];
                    case 2:
                        collations = _e.sent();
                        utils_1.logger.debug("Running estimation on " + collations.length + " collation(s)");
                        return [4 /*yield*/, convertCollationsToStops_1.convertCollationsToStops(collations)];
                    case 3:
                        stops = _e.sent();
                        return [4 /*yield*/, this.getSubco];
                    case 4:
                        subco = _e.sent();
                        return [4 /*yield*/, convertSubcoToDepot_1.convertSubcoToDepot(subco)];
                    case 5:
                        depot = _e.sent();
                        return [4 /*yield*/, Tour.makeRequest("/spatial/functions/optimize/estimation", __1.METHOD.POST, {
                                departure: ((departureTime && moment_1.default(departureTime)) ||
                                    subco.getDefaultStartTime).toISOString(),
                                depot: depot,
                                handlingTime: handlingTime,
                                stops: stops,
                            })];
                    case 6:
                        result = (_e.sent()).result;
                        return [4 /*yield*/, mapOptimizationResults_1.mapOptimizationResults(result, collations, false)];
                    case 7:
                        _e.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // This will create a copy of the current Tour, it's Collations and the Estimations
    // Attached to the Collations. They will not have id's will not be stored on the server
    // and will therefor be unlocked.
    Tour.prototype.unlock = function () {
        return __awaiter(this, void 0, void 0, function () {
            var collations, _a, _b, collationClones, tourClone;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = Promise).all;
                        return [4 /*yield*/, this.getCollations];
                    case 1: return [4 /*yield*/, _b.apply(_a, [_c.sent()])];
                    case 2:
                        collations = _c.sent();
                        return [4 /*yield*/, Promise.all(collations.map(function (collation) { return __awaiter(_this, void 0, void 0, function () {
                                var estimation, clone;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, collation.getEstimation];
                                        case 1:
                                            estimation = _a.sent();
                                            clone = collation.copy();
                                            clone.setEstimation = estimation.copy();
                                            return [2 /*return*/, clone];
                                    }
                                });
                            }); }))];
                    case 3:
                        collationClones = _c.sent();
                        tourClone = new Tour(undefined, (this.getDate && this.getDate.format('YYYY-MM-DD')) ||
                            moment_1.default().format('YYYY-MM-DD'), this.getSubcoId || 1, this.getDriverId, this.getColor);
                        tourClone.setCollations = collationClones;
                        return [2 /*return*/, tourClone];
                }
            });
        });
    };
    Tour.prototype.isLocked = function () {
        return this.getId;
    };
    Tour.prototype.isPlanned = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ledger, v0, state;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLedger];
                    case 1:
                        ledger = _a.sent();
                        v0 = ledger && ledger.find(function (entry) { return entry.getVersion === 0; });
                        if (!v0) return [3 /*break*/, 3];
                        return [4 /*yield*/, v0.getState];
                    case 2:
                        state = _a.sent();
                        return [2 /*return*/, (state && !(['CREATED', 'DISCARDED'].indexOf(state.getName || '') > -1))];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    Tour.fetch = function (tourId) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Tour.makeRequest("/spatial/private/tour/" + tourId, __1.METHOD.GET)];
                case 1:
                    result = (_a.sent()).result;
                    return [2 /*return*/, new Tour(result.id, result.date, result.subcontractorId, result.driverId, result.color)];
            }
        });
    }); };
    Tour.isActiveToursDriverLocked = function (subcoId) {
        return Tour.makeRequest("/spatial/private/are-tours-driver-locked/" + subcoId, __1.METHOD.GET);
    };
    Tour.isActiveToursPlanningLocked = function (subcoId) {
        return Tour.makeRequest("/spatial/private/are-tours-planning-locked/" + subcoId, __1.METHOD.GET);
    };
    Tour.saveTourCollations = function (subcontractorId, tourOverview) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Tour.makeRequest("spatial/public/save/tour/collations/" + subcontractorId, __1.METHOD.POST, tourOverview)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.map(function (tourPart) {
                            var tour = new Tour(tourPart.id, tourPart.date, tourPart.subcontractorId, lodash_1.get(tourPart, 'driverId'), lodash_1.get(tourPart, 'color'));
                            tour.collations = tourPart.collations.map(function (collation) {
                                var collationModel = new __1.TourCollation(collation.id, tourPart.id, collation.shipmentId, collation.position, lodash_1.get(collation, 'polyline'));
                                if (collation.estimation) {
                                    collationModel.setEstimation = Array.isArray(collation.estimation)
                                        ? collation.estimation.map(function (eta) {
                                            return new __1.Estimation(eta.id, collation.id, moment_1.default(eta.estimatedTimeOfArrival).toISOString());
                                        })
                                        : new __1.Estimation(collation.estimation.id, collation.id, moment_1.default(collation.estimation.estimatedTimeOfArrival).toISOString());
                                }
                                return collationModel;
                            });
                            return tour;
                        })];
            }
        });
    }); };
    Tour.fetchBySubcoId = function (subcoId) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Tour.makeRequest("/spatial/private/tour/", __1.METHOD.GET, {
                        filter: {
                            order: {
                                id: 'DESC',
                            },
                            where: {
                                date: moment_1.default().format("YYYY-MM-DD"),
                                subcontractorId: subcoId,
                            },
                        },
                    })];
                case 1:
                    result = (_a.sent()).result;
                    return [2 /*return*/, result.map(function (_a) {
                            var id = _a.id, date = _a.date, subcontractorId = _a.subcontractorId, driverId = _a.driverId, color = _a.color;
                            return new Tour(id, date, subcontractorId, driverId, color);
                        })];
            }
        });
    }); };
    Tour.fetchByDateAndDriverId = function (tourDate, tourDriverId) { return __awaiter(_this, void 0, void 0, function () {
        var tours;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Tour.makeRequest("/spatial/functions/tours-for-driver/date/" + tourDate.format('YYYY-MM-DD') + "/driver/" + tourDriverId, __1.METHOD.GET, {})];
                case 1:
                    tours = (_a.sent()).tours;
                    return [2 /*return*/, tours.map(function (_a) {
                            var id = _a.id, date = _a.date, subcoId = _a.subcoId, driverId = _a.driverId, color = _a.color;
                            return new Tour(id, date, subcoId, driverId, color);
                        })];
            }
        });
    }); };
    Tour.createEmptyTour = function (date, subcoId, color) {
        if (color === void 0) { color = ''; }
        var tour = new Tour(undefined, date.format('YYYY-MM-DD'), subcoId, undefined, color);
        tour.setCollations = [
            new __1.TourCollation(undefined, undefined, -1, 0),
            new __1.TourCollation(undefined, undefined, -2, 1),
        ];
        return tour;
    };
    /**
     * groups shipments together based on proximity to one another.
     * returns a two dimensional array of shipment_id: number
     * @param shipments
     * @param subcontractor
     * @param options
     * @param { Date } delayTime
     * @return { number[][] } shipmentIds
     */
    Tour.generateTourGroupings = function (shipments, subcontractor, options, delayTime) { return __awaiter(_this, void 0, void 0, function () {
        var grouping;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, generateRoutes_1.generateRoutes(shipments, subcontractor, options)];
                case 1:
                    grouping = _a.sent();
                    if (!(!grouping.finished || !grouping.result)) return [3 /*break*/, 3];
                    return [4 /*yield*/, delay_1.default(delayTime || 2500)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, Tour.generateTourGroupings(shipments, subcontractor, options)];
                case 3:
                    if (grouping.result instanceof Error) {
                        throw grouping.result;
                    }
                    return [2 /*return*/, grouping.result];
            }
        });
    }); };
    /**
     * optimizes a group of shipments.
     * @param group
     * @param subcontractor
     * @param departureTime
     * @param handlingTime
     */
    Tour.optimizeGroupWithEstimations = function (group, subcontractor, departureTime, handlingTime) {
        if (handlingTime === void 0) { handlingTime = 180; }
        return __awaiter(_this, void 0, void 0, function () {
            var depot, stops, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, convertSubcoToDepot_1.convertSubcoToDepot(subcontractor)];
                    case 1:
                        depot = _a.sent();
                        stops = group
                            .filter(function (shipment) { return !!shipment; })
                            .map(function (shipment) { return ({
                            id: shipment.id,
                            latitude: shipment.recipient.location.latitude,
                            longitude: shipment.recipient.location.longitude,
                        }); });
                        return [4 /*yield*/, Tour.makeRequest("/spatial/functions/optimize/tsp", __1.METHOD.POST, {
                                departure: ((departureTime && moment_1.default(departureTime)) ||
                                    subcontractor.getDefaultStartTime).toISOString(),
                                depot: depot,
                                handlingTime: handlingTime,
                                stops: stops,
                            })];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * optimizes a group of shipments.
     * @param group
     * @param subcontractor
     * @param departureTime
     * @param handlingTime
     */
    Tour.fetchEstimations = function (group, subcontractor, departureTime, handlingTime) {
        if (handlingTime === void 0) { handlingTime = 180; }
        return __awaiter(_this, void 0, void 0, function () {
            var depot, stops;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, convertSubcoToDepot_1.convertSubcoToDepot(subcontractor)];
                    case 1:
                        depot = _a.sent();
                        stops = group.map(function (shipment) { return ({
                            id: shipment.id,
                            latitude: shipment.recipient.location.latitude,
                            longitude: shipment.recipient.location.longitude,
                        }); });
                        return [4 /*yield*/, Tour.makeRequest("/spatial/functions/optimize/estimation", __1.METHOD.POST, {
                                departure: ((departureTime && moment_1.default(departureTime)) ||
                                    subcontractor.getDefaultStartTime).toISOString(),
                                depot: depot,
                                handlingTime: handlingTime,
                                stops: stops,
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * savesTours en mass
     * @param subcontractorId
     * @param tourOverview
     */
    Tour.saveTours = function (subcontractorId, tourOverview) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Tour.makeRequest("/spatial/functions/update-tour-overview/" + subcontractorId, __1.METHOD.POST, tourOverview)
                /**
                 * @deprecated
                 * @param shipments
                 * @param subcontractor
                 * @param options
                 * @param delayTime
                 */
            ];
        });
    }); };
    /**
     * @deprecated
     * @param shipments
     * @param subcontractor
     * @param options
     * @param delayTime
     */
    Tour.generateTours = function (shipments, subcontractor, options, delayTime) { return __awaiter(_this, void 0, void 0, function () {
        var grouping;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, generateRoutes_1.generateRoutes(shipments, subcontractor, options)];
                case 1:
                    grouping = _a.sent();
                    if (!(!grouping.finished || !grouping.result)) return [3 /*break*/, 3];
                    return [4 /*yield*/, delay_1.default(delayTime || 2500)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, Tour.generateTours(shipments, subcontractor, options)];
                case 3:
                    if (grouping.result instanceof Error) {
                        throw grouping.result;
                    }
                    return [2 /*return*/, Promise.all(grouping.result.map(function (group, tourIndex) { return __awaiter(_this, void 0, void 0, function () {
                            var tour;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        tour = new Tour(undefined, moment_1.default().format('YYYY-MM-DD'), subcontractor.getId, undefined, utils_1.generateColor(tourIndex));
                                        tour.setCollations = [
                                            new __1.TourCollation(undefined, undefined, -1, 0)
                                        ].concat(group.map(function (shipmentId, index) {
                                            return new __1.TourCollation(undefined, undefined, shipmentId, index + 1);
                                        }), [
                                            new __1.TourCollation(undefined, undefined, -2, group.length + 1),
                                        ]);
                                        return [4 /*yield*/, tour.runEstimation({
                                                departureTime: options && options.subcoStartTime,
                                                handlingTime: 180,
                                            })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/, tour];
                                }
                            });
                        }); }))];
            }
        });
    }); };
    Tour.fetchTourOverview = function (tourId, networkType) {
        var defaultNetworkType = networkType || types_1.NETWORK_TYPE.NIGHT;
        return Tour.makeRequest("/spatial/private/tour-overview-via-tour-id/" + tourId + "?networkType=" + defaultNetworkType, __1.METHOD.GET);
    };
    Tour.fetchAllTourOverview = function () {
        return Tour.makeRequest('/spatial/functions/fetch-tour-overview', __1.METHOD.GET);
    };
    Tour.fetchSubCosWithTours = function () {
        return Tour.makeRequest('/spatial/functions/fetch-sub-cos-with-tours', __1.METHOD.GET);
    };
    Tour.fetchSubCoTourOverviews = function (subCoId) {
        return Tour.makeRequest("/spatial/functions/fetch-subco-tour-overviews/" + subCoId, __1.METHOD.GET);
    };
    Tour.fetchDetailedTourOverview = function (tourId) {
        return Tour.makeRequest("/spatial/functions/fetch-tour-overview/" + tourId, __1.METHOD.GET);
    };
    Tour.makePermanent = function (subCoId, networkType) {
        if (networkType === void 0) { networkType = types_1.NETWORK_TYPE.NIGHT; }
        return Tour.makeRequest("/spatial/functions/set-tours-permanent/" + subCoId + "?networkType=" + networkType, __1.METHOD.POST);
    };
    Tour.getProductivityGoalForRegion = function (numberOfShipments, region) {
        return Tour.makeRequest("/spatial/private/region-productivity-goal", __1.METHOD.POST, {
            numberOfShipments: numberOfShipments,
            region: region,
        });
    };
    Tour.getLatestProductivityForSubcontractor = function (subcoId) {
        return Tour.makeRequest("/spatial/private/subco-latest-productivity/" + subcoId, __1.METHOD.GET);
    };
    Tour.setTourDriver = function (tourId, driverId) {
        return Tour.makeRequest('/spatial/functions/set-tour-driver', __1.METHOD.POST, {
            tourId: tourId,
            driverId: driverId,
        });
    };
    Tour.setTourVehicleType = function (tourId, vehicleType) {
        return Tour.makeRequest('/spatial/functions/set-tour-vehicle-type', __1.METHOD.POST, {
            tourId: tourId,
            vehicleType: vehicleType,
        });
    };
    Tour.setAllTourDriversLocked = function (subCoId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Tour.makeRequest("/spatial/functions/set-all-tour-drivers-locked/" + subCoId, __1.METHOD.POST)];
        });
    }); };
    Tour.printShippingDocument = function (tourId) {
        return Tour.makeRequest("/spatial/functions/shipping-document/" + tourId, __1.METHOD.GET, undefined, undefined, {
            'accept': 'application/pdf',
        }, undefined, 'arraybuffer');
    };
    return Tour;
}(Model_1.Model));
exports.Tour = Tour;
